const isValidDate = (date: string | number | Date) =>
  String(new Date(date)) !== 'Invalid Date' && !Number.isNaN(new Date(date));

export default isValidDate;
